export default {
  name: "Cart",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "m26.15 18.28 2.32-9.03c.08-.3.01-.62-.18-.86S27.81 8 27.5 8H9.11l-.52-3.5A1.76 1.76 0 0 0 6.84 3H3.5c-.55 0-1 .45-1 1s.45 1 1 1h3.14l2.75 18.22A2.99 2.99 0 0 0 10.5 29a3 3 0 0 0 2.82-4h7.37a3 3 0 0 0 2.82 4c1.65 0 3-1.35 3-3s-1.35-3-3-3H11.38L11 20.5h12.25c1.35 0 2.54-.91 2.9-2.22zM10.5 27c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm13 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM9.42 10h16.8l-2 7.77a1 1 0 0 1-.96.74H10.7L9.42 10z",
  },
}
